var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassWarlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.728 22.608 1.272 2.203h-5.087l2.544-4.405 1.272 2.203z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.185 18.203 1.272 2.203h-5.087l2.543-4.405 1.272 2.203z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.457 20.405-2.544 4.405-2.543-4.405z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25.641 13.797 1.272 2.203h-5.087l2.543-4.405 1.272 2.203z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m26.913 16-2.543 4.405-2.543-4.405h5.087z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m25.215 22.636 1.255 2.175h-5.022l2.511-4.349z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m23.098 9.392 1.272 2.203h-5.087l2.543-4.405 1.272 2.203z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m24.369 11.595-2.543 4.405-2.543-4.405h5.087z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m22.703 18.287 1.255 2.175h-5.022l2.511-4.35 1.255 2.175z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m23.959 20.462-2.511 4.349-2.511-4.349z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m20.193 13.937 1.255 2.175h-5.022l2.511-4.35 1.255 2.175z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m21.448 16.112-2.511 4.35-2.511-4.35z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m19.695 22.683 1.229 2.128h-4.915l2.457-4.256z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m17.281 9.392 1.272 2.203-2.543 4.405-2.543-4.405 2.543-4.405 1.272 2.203z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m17.238 18.427 1.228 2.128h-4.914l2.457-4.256z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m18.466 20.555-2.457 4.256-2.457-4.256z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m14.78 22.683 1.229 2.128h-4.914l2.457-4.256z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m14.342 13.937 1.255 2.175h-5.022l2.511-4.35 1.255 2.175z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m15.597 16.112-2.511 4.35-2.511-4.35z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m11.83 18.287 1.256 2.175h-5.022l2.511-4.35z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m13.086 20.462-2.511 4.349-2.511-4.349z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m11.445 9.392 1.272 2.203h-5.087l2.544-4.405 1.272 2.203z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m12.717 11.595-2.543 4.405-2.544-4.405z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m9.319 22.636 1.255 2.175h-5.022l2.511-4.349 1.255 2.174z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m8.902 13.797 1.272 2.203h-5.087l2.543-4.405 1.272 2.203z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m10.174 16-2.544 4.405-2.543-4.405z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m6.358 18.203 1.272 2.203h-5.087l2.543-4.405 1.272 2.203z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m7.63 20.405-2.543 4.405-2.543-4.405h5.087z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m3.815 22.608 1.272 2.203h-5.087l2.543-4.405 1.272 2.203z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassWarlock);
export default __webpack_public_path__ + "static/media/class-warlock.4bce7d9875cf50e7ecc46dc3e0933424.svg";
export { ForwardRef as ReactComponent };